<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-primary text-white">
      <h5 class="modal-title">
        Confirmation
      </h5>
    </header>
    <div class="modal-body">
      <h6 v-html-sanitize="messageTitle"></h6>
    </div>
    <footer class="modal-footer">
      <button
        @click="handleDismiss"
        type="button"
        class="btn btn-secondary text-white mr-5"
      >
        Cancel</button
      ><button
        @click="handleConfirm('payNow')"
        type="button"
        class="btn btn-primary"
      >
        {{ options.removeButtonTitle ? options.removeButtonTitle : "Pay Now" }}
      </button>
      <button
        @click="handleConfirm('payLater')"
        type="button"
        class="btn btn-primary"
      >
        {{
          options.removeButtonTitle ? options.removeButtonTitle : "Pay Later"
        }}
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogPaymentOptionsConfirm",
  mixins: [DialogMixin],
  methods: {
    handleConfirm(option) {
      this.proceed(option); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped="">
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
